// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shared-table-skeleton {
  width: 100%;
  background: var(--surface-primary, #fff);
}
.shared-table-skeleton__row {
  min-height: 52px;
  display: flex;
  align-items: center;
  gap: clamp(12px, 3vw, 40px);
  padding: 10px 16px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.shared-table-skeleton__row .app-skeleton {
  flex: 0 1 auto;
}
@media (max-width: 600px) {
  .shared-table-skeleton__row {
    min-height: 76px;
    flex-wrap: wrap;
    gap: 10px 18px;
  }
  .shared-table-skeleton__row .app-skeleton {
    width: calc(50% - 9px) !important;
  }
  .shared-table-skeleton__row .app-skeleton:last-child {
    width: 24% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BTable/bTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;EACA;IACE,iCAAiC;EACnC;EACA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".shared-table-skeleton {\n  width: 100%;\n  background: var(--surface-primary, #fff);\n}\n.shared-table-skeleton__row {\n  min-height: 52px;\n  display: flex;\n  align-items: center;\n  gap: clamp(12px, 3vw, 40px);\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.shared-table-skeleton__row .app-skeleton {\n  flex: 0 1 auto;\n}\n@media (max-width: 600px) {\n  .shared-table-skeleton__row {\n    min-height: 76px;\n    flex-wrap: wrap;\n    gap: 10px 18px;\n  }\n  .shared-table-skeleton__row .app-skeleton {\n    width: calc(50% - 9px) !important;\n  }\n  .shared-table-skeleton__row .app-skeleton:last-child {\n    width: 24% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
